<template>
  <v-dialog v-model="dialog" width="448">
    <template v-slot:activator="{ on }">
      <slot v-bind:on="on" v-bind:disabled="!hasAdminRights">
        <v-icon v-on="on" :disabled="!hasAdminRights">
          mdi-delete
        </v-icon>
      </slot>
    </template>
    <v-card v-if="hasAdminRights">
      <v-card-title class="headline">
        {{
          $t(
            `Supprimer la société ?`,
            `Supprimer les ${entities.length} sociétés ?`,
            entities.length
          )
        }}
      </v-card-title>
      <v-card-text>
        {{
          $t(
            `Confirmez la suppression de ${entities[0]
              .entityMessage()
              .toLowerCase()}.`,
            `Confirmez la suppresion des ${entities.length} sociétés sélectionnés.`,
            entities.length
          )
        }}
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="grey" text @click="cancelDeletation">
          {{ $t("Annuler") }}
        </v-btn>
        <v-btn color="primary" text @click="confirmDeletation">
          {{ $t("Oui, supprimer") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import asyncForEach from "async-await-foreach";
import { createNamespacedHelpers } from "vuex";
import { DELETE_ONE } from "@/store/action-types";
import { Company } from "@/models/Company";

const { mapGetters: mapAuthGetters } = createNamespacedHelpers(`auth`);
const { mapActions: mapCompanyActions } = createNamespacedHelpers(`company`);

export default {
  props: {
    entities: {
      type: Array,
      required: false,
      default: () => [new Company()]
    }
  },
  data() {
    return {
      loading: false,
      dialog: false
    };
  },
  computed: {
    ...mapAuthGetters(["hasAdminRights"])
  },
  methods: {
    ...mapCompanyActions({
      delete: DELETE_ONE
    }),
    async confirmDeletation() {
      this.$gtm.trackEvent({
        event: "interaction",
        category: "company",
        action: "Click (Confirmation suppression société)",
        label: "Confirmation suppression société"
      });

      this.loading = true;
      await asyncForEach(this.entities, async entity => {
        await this.delete(entity);
      });
      this.loading = false;

      this.$emit("success");

      this.dialog = false;
    },
    cancelDeletation() {
      this.$gtm.trackEvent({
        event: "interaction",
        category: "company",
        action: "Click (Annulation suppression société)",
        label: "Annulation suppression société"
      });

      this.dialog = false;
    }
  },
  watch: {
    dialog(value) {
      if (value) {
        this.$gtm.trackEvent({
          event: "interaction",
          category: "company",
          action: "Click (Ouverture modal suppression société)",
          label: "Ouverture modal suppression société"
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.v-expansion-panel-content.no-padding::v-deep {
  > .v-expansion-panel-content__wrap {
    padding-left: 0;
    padding-right: 0;
    padding-bottom: 0;
  }
}
</style>
